import { useDispatch, useSelector } from 'react-redux';

import { setAlertAction, clearAlertAction, getAlert } from 'features/alert/redux/slice';

import { AlertState, UseAlertState } from './types';
import { AxiosError } from 'axios';

const useAlert = (): UseAlertState => {
  const { type, message } = useSelector(getAlert);
  const dispatch = useDispatch();

  const setAlert = (alert: AlertState) => {
    dispatch(setAlertAction(alert));
  };

  const clearAlert = () => {
    dispatch(clearAlertAction());
  };

  const handlingError = (error: AxiosError<any>): void => {
    let errorMessage = 'Ocorreu um erro inesperado. Por favor, tente novamente.';

    if (error?.message) {
      errorMessage = error.message;
    } else if (JSON.stringify(error).indexOf('Network Error') !== -1) {
      errorMessage = 'Ocorreu um erro ao tentar acessar o servidor. Por favor, tente novamente.';
    } else if (error?.response) {
      if (error?.response?.data) {
        if (error?.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.messages) {
          if (error.response.data.messages.errors) {
            const errorMessages: string[] = [];

            error.response.data.messages.errors.forEach((item: any) => {
              errorMessages.push(`• ${item.message}`);
            });

            errorMessage = errorMessages.join('<br />');
          }
        }
      }
    } else if (error.request) {
      errorMessage = error.request;
    }

    setAlert({ type: 'error', message: errorMessage });
  };

  return {
    setAlert,
    clearAlert,
    handlingError,
    alert: {
      type,
      message,
    },
  };
};

export default useAlert;
